/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { TowerCO2 } from "./modelTowerCO2";

class ControllerTowerCO2 extends ControllerModel {
  constructor() {
    super("ControllerTowerCO2");
    
    this.setNewNode = (callback) => {
      let towerCO2 = new TowerCO2();
      towerCO2.decorate(callback);

      this.addNode(towerCO2);
    }

    this.loadNode = (node, callback) => {
      let towerCO2 = new TowerCO2();
      towerCO2.copyFrom(node);
      towerCO2.decorate(callback);
      this.addNode(towerCO2)
    }

    this.getProperties = async (node) => {
      let n = new TowerCO2();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new TowerCO2();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerTowerCO2 };
